import { jsx as _jsx } from "react/jsx-runtime";
import { PlayCircleFillIcon } from '@yonderland/andes-icons';
import { PillButton } from '@yonderland/andes-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useProductMedia } from './useProductMedia';
export const PlayVideoButton = ({ onClick, size = 'md' }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { mediaCollection } = useProductMedia();
    const videoCount = useMemo(() => mediaCollection.filter(item => item.isVideo).length, [mediaCollection]);
    if (videoCount === 0)
        return null;
    const buttonText = t('pdp.video.count', { count: videoCount });
    return (_jsx(PillButton, { inverse: true, theme: "branded", variant: "primary", testId: "product-video-button", size: size, onClick: onClick, iconLeft: { source: PlayCircleFillIcon, size }, text: buttonText }));
};
